import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronDoubleRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronDoubleRight"><Path fillRule="evenodd" clipRule="evenodd" d="M7.00015 6.58594L12.4144 12.0002L7.00015 17.4144L5.58594 16.0002L9.58594 12.0002L5.58594 8.00015L7.00015 6.58594ZM14.0002 6.58594L19.4144 12.0002L14.0002 17.4144L12.5859 16.0002L16.5859 12.0002L12.5859 8.00015L14.0002 6.58594Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronDoubleRight;
